import { resolveImageSrc } from '../utils/resolveImageSrc';

function CategorySidebar({ categories, activeCategoryId, onChange }) {
  return (
    <aside className="left">
      {categories.map((category) => {
        const active = category.id === activeCategoryId;
        const imageSrc = resolveImageSrc(category.image);

        return (
          <button
            key={category.id}
            type="button"
            className={`category ${active ? 'active' : ''}`}
            onClick={() => onChange(category.id)}
          >
            <span className="categoryMedia" aria-hidden="true">
              {imageSrc ? (
                <img className="categoryImage" src={imageSrc} alt="" />
              ) : (
                <span className="categoryEmoji">{category.emoji}</span>
              )}
            </span>
            <span className="categoryName">{category.name}</span>
          </button>
        );
      })}
    </aside>
  );
}

export default CategorySidebar;
